import { useMemo } from "react";
import { useModelLedger } from "@/zapi-frontend/pages/ProjectDetailsPage/ui/ModelLedgerIsland/useModelLedger";
import { fillChapterContent, hasEmptySlots } from "@/zapi-frontend/shared/lib/figureRefs";
import type { TLedgerFigure } from "@/zapi-frontend/shared/types/modelLedger";

export type TFilledMemoContent = {
  content: string | undefined;
  figures: TLedgerFigure[] | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

export function useFilledMemoContent(
  projectId: string | number | undefined,
  memo: { mdContent?: string | null; contentFormat?: string | null } | null | undefined
): TFilledMemoContent {
  const isBlocks = memo?.contentFormat === "blocks";
  const ledger = useModelLedger(projectId === undefined ? "" : String(projectId), { enabled: isBlocks });
  const stored = memo?.mdContent ?? "";
  const figures = ledger.data?.figures;
  const waits = useMemo(() => isBlocks && hasEmptySlots(stored), [isBlocks, stored]);
  const isLoading = waits && ledger.isLoading;
  const isError = waits && ledger.isError;
  const content = useMemo(() => {
    if (!isBlocks) return stored;
    if (isLoading || isError) return undefined;
    return fillChapterContent(stored, figures);
  }, [isBlocks, isLoading, isError, stored, figures]);
  return { content, figures, isLoading, isError, refetch: () => void ledger.refetch() };
}
